import React, { useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import cx from "classnames";
import { EyeOutlined, EyeInvisibleOutlined } from "@ant-design/icons";

const InputS1 = ({
	className = null,
	label = "",
	readOnly = false,
	placeholder = "",
	type = "text",
	size = "default",
	field,
	disabled = false,
	isRequired = false,
	validate,
	prependData,
	autoFocus,
	form: { touched, errors },
	...props
}) => {
	const { t } = useTranslation("main");
	const [visible, setVisible] = useState(false);

	const isPassword = type === "password";
	const inputType = isPassword ? (visible ? "text" : "password") : type;

	const classes = cx(
		"form-field",
		touched[field.name] && errors[field.name] && "form-field--error",
		`form-field--${size}`,
		disabled && `form-field--disabled`,
		field.value && "form-field--active",
		className
	);

	return (
		<div className={classes}>
			{label && (
				<label className="form-field__label">
					{label}
					{isRequired && <span title={"Обязательное поле"}>*</span>}
				</label>
			)}

			<div className="input-group">
				<input
					className="form-field__input"
					autoComplete="off"
					readOnly={readOnly}
					disabled={disabled}
					autoFocus={autoFocus}
					{...{ placeholder }}
					type={inputType}
					{...field}
					{...props}
				/>

				{/* 👁 Eye icon for password */}
				{isPassword && (
					<div
						className="form-field__icon"
						onClick={() => setVisible(prev => !prev)}
						style={{
							cursor: "pointer",
							position: "absolute",
							right: 12,
							top: "50%",
							transform: "translateY(-50%)"
						}}
					>
						{visible ? <EyeInvisibleOutlined /> : <EyeOutlined />}
					</div>
				)}

				{prependData && prependData}

				{touched[field.name] && errors[field.name] && (
					<div className="form-field__error">
						<span>{t(errors[field.name])}</span>
					</div>
				)}
			</div>
		</div>
	);
};

InputS1.propTypes = {
	label: PropTypes.string,
	type: PropTypes.oneOf(["text", "password", "number"]),
	className: PropTypes.string,
	placeholder: PropTypes.string,
	readOnly: PropTypes.bool,
	size: PropTypes.oneOf(["default", "large", "small", "extra-small"]),
	disabled: PropTypes.bool,
	isRequired: PropTypes.bool
};

export default InputS1;
